@if (label) {
  <p class="_label"
    [dfs]="'t:p1'"
  >{{label}}</p>
}
<div [offClickState]="expandState"
  (offClick)="closeDropdown()">

  <div class="_content">

    <!-- loader -->
    @if (isLoaderVisible) {
      <icms-loader class="_loader"
      ></icms-loader>
    }

    <!-- side icon (optional) -->
    @if (sideIcon) {
      <icms-icon class="_sideIcon"
        [class._hasAction]="hasSideAction"
        (click)="sideAction()"
        [class.col-3]="sideIcon === 'tick'"
      [icon]="sideIcon"></icms-icon>
    }

    <!-- side text (optional) -->
    <span class="_sideText"
      [dfs]="'t:s1'"
    (click)="sideAction()">{{ sideText }}</span>

    <!-- custom arrows for number type input -->
    @if (!isLoaderVisible) {
      <div [dfs]="'d:flex flex-direction:column'"
        class="_arrows"
        >
        <icms-icon class="_arrowUp"
        [icon]="'chevron-up'"></icms-icon>
        <icms-icon class="_arrowDown"
        [icon]="'chevron-down'"></icms-icon>
      </div>
    }
    <ng-content></ng-content>
  </div>



  @if (isValidationVisible) {
    <p [dfs]="'t:p2 m-t:1q c:2'"
    >{{ validationMsg }}</p>
  }

  @if (error && !isValidationVisible) {
    <p [dfs]="'t:p2 m-t:1q c:2'"
    >{{ error }}</p>
  }

  @if (helper && !error && !isValidationVisible) {
    <p [dfs]="'t:p2 m-t:1q'"
    >{{ helper }}</p>
  }


  @if (type && ['date','time'].includes(type) && !isDisabled) {
    <div [dfs]="'pos:absolute z:10 right:-10px'"
      >
      <!-- padding is to make sure that shadow is visible -->
      <div [iCmshideUp]="expandState">
        @if (type==='date' && calendarOptions) {
          <icms-calendar
            [triangle]="true"
            [(model)]="inDropdownValue"
            (modelChange)="closeDropdown()"
          [options]="calendarOptions"></icms-calendar>
        }
        @if (type==='time') {
          <icms-timepicker
            [triangle]="true"
            (modelChange)="closeDropdown()"
            [openState]="expandState"
          [(model)]="inDropdownValue"></icms-timepicker>
        }
      </div>
    </div>
  }
</div>
